import React, { useEffect, useRef } from 'react';
import { translate } from '../Services/translation';
import { useDispatch, useSelector } from "react-redux";
import { doShowResult, query as runQuery, selectOrganization, setSearchQuery } from "../Actions/OrganizationSearch.action";
import { Svg } from "./Svg";

const AdditionalOrgsResultItem = ({qtyOverInitial}) => {
    let text = translate('nmas.login.selectorganization.results.info.item');
    text = text.replace('{x}', qtyOverInitial);

    return <TextResultItem>{text}</TextResultItem>
}

const TextResultItem = ({children}) => {
    return (<li className='select-organization-result__more-orgs-item no-hover'>{children}</li>);
}

const OrganizationSearchResults = () => {
    const dispatch = useDispatch();
    const initialShow = 5;
    const {
        query,
        result,
        showResult,
        selectedItem,
        redirectUrl
    } = useSelector(state => state.organizationSearch);

    let resultsToShow = result;
    if (result.length && query && query.length) {
        resultsToShow = resultsToShow.filter(r => {
            let decodedQuery = decodeURIComponent(query);
            const lowerCaseQuery = decodedQuery.toLowerCase();
            const nameMatches = r.name.toLowerCase().indexOf(lowerCaseQuery) !== -1;
            const address3Matches = r.address3.toLowerCase().indexOf(lowerCaseQuery) !== -1;
            const address4Matches = r.address4.toLowerCase().indexOf(lowerCaseQuery) !== -1;
            return nameMatches || address3Matches || address4Matches;
        });
    }

    let moreThanInitial = query.length <= 0 && resultsToShow.length > initialShow;
    let qtyOverInitial = resultsToShow.length - initialShow;

    if (moreThanInitial) {
        resultsToShow = resultsToShow.slice(0, initialShow);
    }

    return (showResult && resultsToShow.length !== 0 ? (
        <div className="select-organization-result__result-wrapper">
            <ul className="select-organization-result__result">
                {resultsToShow &&
                    resultsToShow.map((item, index) => (
                        <li
                            className={`select-organization-result__result__item ${
                                selectedItem === index
                                    ? 'select-organization-result__result__item--selected'
                                    : ''
                            }`}
                            key={`${item.name}-${index}`}
                        >
                            <a
                                className={`select-organization-result__result__link`}
                                onClick={() =>
                                    dispatch(selectOrganization(
                                        item.id,
                                        redirectUrl ? redirectUrl : '/',
                                    ))
                                }
                            >
                                <div>{item.name}</div>
                            </a>
                        </li>
                    ))}

                {moreThanInitial && (
                    <AdditionalOrgsResultItem {...{ qtyOverInitial }} />
                )}
            </ul>
        </div>
    ) : showResult && resultsToShow.length === 0 ? (
        <span className={`select-organization-result__result__link`}>
            <TextResultItem>{translate('nmas.search.nohit')}</TextResultItem>
        </span>
    ) : null);
}

const OrganizationSearch = (props) => {
    const dispatch = useDispatch();
    const searchInputRef = useRef();
    const clearSearchRef = useRef();
    const {
        query,
        result,
        showResult,
    } = useSelector(state => state.organizationSearch);

    /**
     * @param {MouseEvent} e
     * @returns {boolean|null}
     */
    const onBlur = (e) => {
        let parentElement = document.querySelector('#organizationSearch');
        if (!parentElement) return null;

        let targetWithInParent = parentElement === e.target || parentElement.contains(e.target) || clearSearchRef.current === e.target;
        !targetWithInParent && dispatch(doShowResult(false));
    };

    useEffect(() => {
        dispatch(runQuery());
    }, []);

    useEffect(() => {
        setTimeout(() => {
            searchInputRef.current && searchInputRef.current.focus();
        }, 0);

        document.addEventListener('click', onBlur);
        return () => document.removeEventListener('click', onBlur);
    }, [result]);

    if (!result) {
        return <></>;
    }

    return (
        <div className={`select-organization ${(showResult ? 'results-open' : '')}`}>
            <h3 className="select-organization__title" style={{marginLeft: '1.5rem'}}>
                {translate('nmas.login.selectorganization')}
            </h3>

            <div className="select-organization__search" role="search">
                <div className={`select-organization__search__form`} role="search">
                    <input
                        className="select-organization__search__input form__input"
                        type="text"
                        placeholder={translate('general.search')}
                        autoComplete="off"
                        value={decodeURIComponent(query)}
                        onFocus={() => dispatch(doShowResult(true))}
                        onChange={e =>
                            dispatch(setSearchQuery(encodeURIComponent(e.target.value)))
                        }
                        ref={searchInputRef}
                    />

                    {((showResult && query.length <= 0) || !showResult) && <span><Svg icon='magnifying-glass'/></span>}
                    {showResult && query.length > 0 && <span onClick={() => {
                        dispatch(setSearchQuery(''))
                    }} ref={clearSearchRef}><Svg icon='close' /></span>}
                </div>

                <div className="select-organization-result__container">
                    <OrganizationSearchResults />
                </div>
            </div>
        </div>
    );
}

export default OrganizationSearch;
